<template>
  <div class="quote-info-input">
    <div class="form-area">
      <div class="title">見積書発行</div>
      <p class='error_top'>{{ error }}</p>
      <div class="input-group">
        <label class="input-label">お名前</label>
        <input type="text" class="type-text" name="name" v-model="name" :disabled="loading" @change='contactInput'>
        <select v-model="name_appended">
          <option value="様">様</option>
          <option value="御中">御中</option>
          <option value=""></option>
        </select>
      </div>
      <div class="input-group">
        <label class="input-label">見積額</label>
        <input type="text" class="type-text text-right" inputmode="numeric" pattern="[0-9]*"
               onkeypress='return /[\d]/.test(event.key)' v-model="amount" :disabled="loading"
               @change="contactInput">
        <span>円</span>
      </div>
      <div class="input-group">
        <label class="input-label">消費税<br>{{ taxRateDisplay }}%</label>
        <input type="text" class="type-text text-right" inputmode="numeric" pattern="[0-9]*"
               onkeypress='return /[\d]/.test(event.key)' v-model="tax" readonly>
        <span>円</span>
      </div>
      <div class="input-group">
        <label class="input-label">合計</label>
        <input type="text" class="type-text text-right" inputmode="numeric" pattern="[0-9]*"
               onkeypress='return /[\d]/.test(event.key)' v-model="total" readonly>
        <span>円</span>
      </div>
      <div class="input-group">
        <label class="input-label">送信先</label>
        <label class="radio">
          <input type="radio" name='contact_type'
                 value='sms'
                 v-model='contact_type' :disabled="loading" @change='contactInput'>
          SMS
        </label>
        <i>/</i>
        <label class="radio">
          <input type="radio" name='contact_type'
                 value='email'
                 v-model='contact_type' :disabled="loading" @change='contactInput'>
          Email
        </label>
      </div>
      <div class="input-group" v-if='contact_type=="email"'>
        <label class="input-label">Email</label>
        <input type="text" class="type-text"
               v-model='contact'
               @change='contactInput' :disabled="loading">
      </div>
      <div class="input-group" v-if='contact_type=="sms"'>
        <label class="input-label">SMS</label>
        <input type="text" class="type-text"
               v-model='contact'
               @change='contactInput' :disabled="loading">
      </div>
      <p class='error'>{{ error }}</p>
    </div>
    <div class="floating-actions">
      <button class="btn" type='button' @click="back">
        一つ前に戻る
      </button>
      <button class="btn" type='button' :disabled="!submitable" @click="submit">
        保存して発行
      </button>
    </div>
  </div>
</template>
<script>
const regexs = {
  phone: /^\+*\d+$/,
  email: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
};
export default {
  name: 'orderQuoteInfoInput',
  data: function () {
    return {
      name: '',
      name_appended: '様',
      amount: '',
      tax: '',
      taxRate: 0,
      total: 0,
      contact_type: '',
      contact: '',
      loading: false,
      error: ''
    }
  },
  computed: {
    submitable: function () {
      return this.name !== '' &&
          this.contact_type !== '' &&
          this.contact !== '' &&
          this.error === '' &&
          this.loading === false
    },
    taxRateDisplay: function () {
      return (this.taxRate !== 0) ? (this.taxRate * 100) : 0
    }
  },
  methods: {
    calc: function () {
      this.tax = Math.floor(this.amount * this.taxRate);
      this.total = Math.floor(this.amount) + Math.floor(this.tax);
    },
    contactInput: function () {
      if (this.contact === '') {
        this.error = '';
        return false;
      }
      var checker = this.contact_type === 'sms' ? regexs['phone'] : regexs['email'];
      if (checker.test(this.contact)) {
        this.error = '';
      } else {
        this.error = this.contact_type === 'sms' ? '電話番号が正しくありません' : "Emailが正しくありません";
      }
      this.calc();
    },
    load: function () {
      this.loading = true;
      this.$api.getOrderQuote(this.$route.params.id)
          .then((res) => {
            this.loading = false;
            this.name = res.data.data.name;
            this.name_appended = res.data.data.name_appended;
            this.amount = res.data.data.amount;
            this.tax = res.data.data.tax;
            this.taxRate = res.data.data.taxRate;
            this.contact_type = res.data.data.type === 0 ? 'sms' : 'email';
            this.contact = res.data.data.contact;
            this.calc();
          })
          .catch(() => {
            this.loading = false;
          });
    },
    back: function () {
      this.$router.go(-1)
    },
    submit: function () {
      if (!this.loading) {
        let order_id = this.$route.params.id,
            params = {
              type: this.contact_type === 'sms' ? 0 : 1,
              name: this.name,
              name_appended: this.name_appended,
              amount: this.amount,
              tax: this.tax
            };
        if (this.contact_type === 'sms')
          params.sms = this.contact;
        else
          params.email = this.contact;

        this.loading = true;
        this.$api
            .postOrderQuote(order_id, params)
            .then(() => {
              this.$router.push({name: 'orderDesc', params: {id: this.$route.params.id}});
              this.$$.flash();
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            })
      }
    }
  },
  mounted: function () {
    this.$$.context({
      previous: '戻る',
      title: "見積り:" + this.$route.params.id,
      previousRouteName: 'orderQuoteSteps',
    });
    this.load();
  }
}
</script>
<style lang='scss'>
.quote-info-input {
  padding: 1em;
  margin-bottom: 100px;

  .error {
    color: red;
    margin-left: 50px;
  }

  .error_top {
    color: red;
    text-align: center;
  }

  .input-group {
    margin-top: 1.5em;

    .input-label {
      flex-grow: 0;
      flex-shrink: 0;
      text-align: center;
      margin-right: 2px;
    }

    input.type-text {
      font-size: 1.2em;
      padding: .25em;
      line-height: 1;
      height: auto;
    }

    select {
      font-size: 1.2em;
      padding: .22em;
      height: auto;
    }

    .text-right {
      text-align: right;
    }

    span {
      font-size: 1.5em;
      padding: 0 .25em;
    }

    &:last-child {
      margin-top: 2.5em;
    }
  }

  .title {
    font-size: 1.125em;
    font-weight: bold;
    text-align: center;
  }
}
</style>